<template>
  <v-page page="activitiesOverview Sankey" :title="`Activities Overview (${chart} Graph)`">
    <v-toolbar class="mt-2" color="grey lighten-2" flat>
      <strong>Your Active Groups in the</strong>
      <v-date-range :options="dateRange.options" :default-option="dateRange.defaultOption" v-model="dateRange.value"></v-date-range>
      <v-spacer/>
      <v-btn-toggle v-model="chart">
        <v-btn v-for="(chartType, chartIndex) in charts" :key="`chart-type-${chartIndex}`" :value="chartType" color="primary darken-2" flat>
          {{ chartType }}
        </v-btn>
      </v-btn-toggle>
    </v-toolbar>
    <v-alert :value="true" type="warning" icon="info" outlined>
      [FAKE DATA – UNDER DEVELOPMENT]
    </v-alert>
    <v-container>
      <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>
      <component :is="chartComponent" v-else-if="!loading"/>
      <v-alert color="grey darken-1" :value="true" v-else>
        There are no activities corresponding to your search
      </v-alert>
    </v-container>
  </v-page>
</template>

<script>
import VPage from '@/layouts/Default'
import VDateRange from '@/components/Filter/DateRange.vue'
import OverviewFunnel from './OverviewFunnel.vue'

export default {
  name: 'ActivitiesOverview',
  components: {
    VPage,
    VDateRange,
    OverviewFunnel
  },
  data () {
    return {
      loading: false,
      dateRange: {
        format: 'YYYY-MM-DD',
        options: ['Today', 'Yesterday', 'Last 7 days', 'Last 30 days', 'Custom...'],
        defaultOption: 'Last 30 days',
        value: {}
      },
      chart: 'Funnel',
      charts: [
        'Funnel',
        'Sankey',
        'Sunburst'
      ]
    }
  },
  computed: {
    /**
     * Import the selected chart component
     */
    chartComponent () {
      const chart = this.chart

      return () => import(`./Overview${chart}.vue`)
    }
  }
}
</script>
